import Homepage1 from "./Homepages/Homepage1";
import Secondpage from "../src/Homepages/Secondpage"
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage1 />} />
        <Route path="/secondpage" element={<Secondpage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
